import { Truck, Download, LogIn } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { BACKEND_URL } from "@/lib/api";

const links = [
  { name: "Live Loads", href: "#load-board", testId: "nav-link-loads" },
  { name: "Carrier Packet", href: "#carrier-packet", testId: "nav-link-carrier-packet" },
  { name: "Carrier Setup", href: "#carrier-signup", testId: "nav-link-signup" },
  { name: "Why FGB", href: "#about", testId: "nav-link-about" },
  { name: "Returns & Support", href: "#contact-returns", testId: "nav-link-contact" },
];

export default function Navbar() {
  const downloadPacket = () => {
    window.open(`${BACKEND_URL}/api/packet/download`, "_blank");
  };
  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#080C14]/85 border-b border-slate-800/80"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 group">
          <div className="h-9 w-9 rounded-lg bg-amber-500/15 border border-amber-500/30 flex items-center justify-center glow-amber">
            <Truck className="h-4.5 w-4.5 text-amber-400" size={18} />
          </div>
          <div className="leading-tight">
            <div className="font-display font-extrabold text-lg tracking-tight text-white">
              FGB <span className="text-amber-400">DISPATCHING</span>
            </div>
            <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-slate-500">
              24/7 Nationwide Dispatch
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <a
              key={l.name}
              href={l.href}
              data-testid={l.testId}
              className="text-sm text-slate-300 hover:text-amber-400 transition-colors"
            >
              {l.name}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            data-testid="nav-download-packet-btn"
            onClick={downloadPacket}
            className="hidden sm:inline-flex border-amber-500/40 text-amber-400 hover:bg-amber-500/10 hover:text-amber-300 bg-transparent"
          >
            <Download className="h-4 w-4 mr-1.5" /> Packet
          </Button>
          <Link to="/admin/login">
            <Button
              size="sm"
              data-testid="nav-admin-login-btn"
              className="bg-amber-500 text-black hover:bg-amber-400 font-semibold"
            >
              <LogIn className="h-4 w-4 mr-1.5" /> Admin
            </Button>
          </Link>
        </div>
      </div>
    </header>
  );
}
